import { CountriesEnum } from '../shared/enum/countries.enum';

export const countryNameByCountry: Record<CountriesEnum, string> = {
    [CountriesEnum.AUSTRIA]: 'Österreich',
    [CountriesEnum.CZECH]: 'Česká republika',
    [CountriesEnum.ESTONIA]: 'Eesti',
    [CountriesEnum.FRANCE]: 'France',
    [CountriesEnum.GERMANY]: 'Deutschland',
    [CountriesEnum.GREECE]: 'Ελλάδα',
    [CountriesEnum.ITALY]: 'Italia',
    [CountriesEnum.NETHERLANDS]: 'Nederland',
    [CountriesEnum.POLAND]: 'Polska',
    [CountriesEnum.PORTUGAL]: 'Portugal',
    [CountriesEnum.RUSSIA]: 'Россия',
    [CountriesEnum.SPAIN]: 'España',
    [CountriesEnum.SWITZERLAND]: 'Schweiz',
    [CountriesEnum.UK]: 'United Kingdom',
    [CountriesEnum.USA]: 'United States',
    [CountriesEnum.FINLAND]: 'Suomi',
    [CountriesEnum.DENMARK]: 'Danmark',
    [CountriesEnum.SLOVAKIA]: 'Slovensko',
    [CountriesEnum.HUNGARY]: 'Magyarország',
    [CountriesEnum.SWEDEN]: 'Sverige',
    [CountriesEnum.LATVIA]: 'Latvija',
    [CountriesEnum.BELGIUM]: 'België',
    [CountriesEnum.CANADA]: 'Canada',
    [CountriesEnum.BULGARIA]: 'България',
    [CountriesEnum.AUSTRALIA]: 'Australia',
    [CountriesEnum.ROMANIA]: 'România',
    [CountriesEnum.LITVA]: 'Lietuva',
    [CountriesEnum.IZRAEL]: 'יִשְׂרָאֵל',
    [CountriesEnum.IRELAND]: 'Ireland',
    [CountriesEnum.CROATIA]: 'Hrvatska',
    [CountriesEnum.NEW_ZEALAND]: 'New Zealand',
    [CountriesEnum.ARGENTINA]: 'Argentina',
    [CountriesEnum.BRAZIL]: 'Brasil',
    [CountriesEnum.TAIWAN]: 'Taiwan',
    [CountriesEnum.MEXICO]: 'México',
    [CountriesEnum.JAPAN]: '日本',
    [CountriesEnum.SERBIA]: 'Srbija',
    [CountriesEnum.SINGAPORE]: 'Singapore',
    [CountriesEnum.NORWAY]: 'Norge',
};
